export enum DisplayMode {
    Heatmap,
    LinkedPoint
}
